import { Box } from "@chakra-ui/react";
import { NumericFormat } from "react-number-format";

import { Input, Text } from "@equidefi/ui";
import { CurrencyFormatter } from "@equidefi/i18n";

import { HighlightCard } from "./HighlightCard";

export function SharesInput({ values, errors, touched, handleBlur, setValues, unitPrice, securitiesLabel }) {
  const displayQuantity =
    values.quantity !== 0 && values.quantity !== "" && values.quantity !== null && values.quantity !== undefined
      ? values.quantity
      : "";

  return (
    <Box>
      <Text mb="2" fontWeight="medium">
        Enter the number of {securitiesLabel} you want to purchase.
      </Text>
      <Input
        maxW="100%"
        isInvalid={errors.quantity && touched.quantity}
        as={NumericFormat}
        name="quantity"
        allowNegative={false}
        thousandSeparator
        value={displayQuantity}
        placeholder="0"
        onBlur={handleBlur}
        onValueChange={({ value }) => {
          const numValue = value === "" ? 0 : Number(value);
          setValues((current) => ({
            ...current,
            quantity: numValue,
            amount: numValue * unitPrice,
          }));
        }}
        decimalScale={0}
        fixedDecimalScale={false}
        error={errors.quantity}
      />

      <HighlightCard title="INVESTMENT AMOUNT" text={CurrencyFormatter.format(values.amount || 0)} />
    </Box>
  );
}
